import { playgroundInitialState, SiteTokenDetails } from '.';
import { isClientSide } from '../../../utils';

const OLD_SESSION_STORAGE_KEY = 'test-token';
const NEW_SESSION_STORAGE_KEY = 'playground-test-site';

export const loadPlaygroundInitialState = (
  initialState = playgroundInitialState,
) => {
  if (isClientSide()) {
    let foundDataInStorage = false;

    try {
      const newItemDataByKey = window.sessionStorage.getItem(
        NEW_SESSION_STORAGE_KEY,
      );
      if (newItemDataByKey) {
        const newItemDataByKeyParsed = JSON.parse(newItemDataByKey);
        initialState.data.selectedSiteTokenDetails = {
          ...newItemDataByKeyParsed,
        };
        foundDataInStorage = true;
      }
    } catch (error) {}

    try {
      if (!foundDataInStorage) {
        const oldItemDataByKey = window.sessionStorage.getItem(
          OLD_SESSION_STORAGE_KEY,
        );
        if (oldItemDataByKey) {
          const oldItemDataByKeyParsed = JSON.parse(oldItemDataByKey);
          initialState.data.selectedSiteTokenDetails = {
            ...oldItemDataByKeyParsed,
          };
        }
      }
    } catch (error) {}

    if (
      initialState.data.selectedSiteTokenDetails.expiryTime &&
      initialState.data.selectedSiteTokenDetails.expiryTime <= Date.now()
    ) {
      delete initialState.data.selectedSiteTokenDetails.expiryTime;
      delete initialState.data.selectedSiteTokenDetails.token;
    }
  }

  return initialState;
};

export const saveSiteTokenDetailsToStorage = (
  selectedSiteTokenDetails: SiteTokenDetails,
) => {
  if (selectedSiteTokenDetails) {
    window.sessionStorage.setItem(
      NEW_SESSION_STORAGE_KEY,
      JSON.stringify(selectedSiteTokenDetails),
    );
  }
};
